import { isNodeJS } from "../../../compat";
import { createWorker } from "../../DtWorkerCreator";

class DtElementCacheWorker {
  #worker;
  #handlers = [];

  constructor(sessionId) {
    this.#worker = createWorker('Element Cache Worker', sessionId);
  }

  connectToPort(messagePort) {
    this.#worker.doOperation({
      operation: "DT_CACHE_INSTALL_PORT",
      port: messagePort
    }, [messagePort]);
  }

  doOperation(...args) {
    this.#worker.doOperation(...args);
  }

  addMessageHandler(callback) {
    this.#handlers.push(callback);
    this.#worker.addEventListener('message', callback);
  }

  removeMessageHandler(callback) {
    const index = this.#handlers.indexOf(callback);
    if (index > -1) {
      this.#handlers.splice(index, 1);
    }
    this.#worker.removeEventListener('message', callback);
  }

  downloadDebugData(modelIds, excludeDbs = false) {
    // A handler that downloads the received debug data to disk and de-registers itself from the message handlers.
    const downloadHandler = (message) => {
      if (message.data.operation !== 'DT_DOWNLOAD_DEBUG_DATA') {
        return;
      }

      // Download a Uint8Array as a file.
      const downloadBlob = (data, fileName) => {
        const blob = new Blob([data.buffer]);
        const url = window.URL.createObjectURL(blob);
        downloadURL(url, fileName);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      };

      const downloadURL = (data, fileName) => {
        const a = document.createElement('a');
        a.href = data;
        a.download = fileName;
        document.body.appendChild(a);
        a.style.display = 'none';
        a.click();
        a.remove();
      };

      downloadBlob(message.data.debugData, 'debugData.zip');

      // Deregister this handler
      this.removeMessageHandler(downloadHandler);
    };

    // Add the download handler and request the debug data.
    this.addMessageHandler(downloadHandler);
    this.doOperation({ operation: 'DT_DOWNLOAD_DEBUG_DATA', modelIds, excludeDbs });
  }
}

// TODO: Is this required? Maybe it is, even though calling code should simply not use this on node.js.
class DtElementCacheWorkerNodeProxy {
  connectToPort() {}

  doOperation() {}

  addMessageHandler() {}

  removeMessageHandler() {}

  downloadDebugData() {}
}

/** @type DtElementCacheWorker */
let elementCacheWorker;
export function getElementCacheWorkerSingleton(sessionId) {
  if (!elementCacheWorker) {
    elementCacheWorker = isNodeJS() ? new DtElementCacheWorkerNodeProxy() : new DtElementCacheWorker(sessionId);
  }
  return elementCacheWorker;
}